<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="4310" height="16" fill="none"><path d="M4309.51 8.38a1 1 0 0 0 0-1.415l-6.37-6.364a.995.995 0 0 0-1.41 0c-.39.39-.39 1.024 0 1.414l5.66 5.657-5.66 5.657a1 1 0 0 0 0 1.414c.39.39 1.02.39 1.41 0l6.37-6.364ZM.326 8.672H4308.8v-2H.326v2Z"/></svg>
</template>